import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { PartialReceiptsItemWithSelected } from '$modules/personal/modules/batch/features/batches/models';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import { BehaviorSubject } from 'rxjs';
import { BatchesParseStorageService } from '../../services';
// tslint:disable-next-line:max-line-length
import { AddAttachmentModalComponent } from '$modules/personal/modules/batch/features/batches/modals/add-attachment-modal/add-attachment-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from '@angular/router';
// tslint:disable-next-line:max-line-length

@Component({
  selector: 'app-attachment-card',
  templateUrl: './attachment-card.component.html',
  styleUrls: ['../view-batch-card/view-batch-card.component.scss'],
})
export class AttachmentCardComponent implements OnInit, OnDestroy {
  public readonly faTrashAlt = faTrashAlt;
  @Input() public departureAttachment: PartialReceiptsItemWithSelected;
  @Input() public isEditable: boolean;

  @Output() public changeCardSelected = new EventEmitter<{
    id: string;
    selected: boolean;
  }>();
  @Output() public deleteAttachments = new EventEmitter<string>();

  public isFullScreen$: BehaviorSubject<boolean> =
    this.batchStorageService.isFullScreen$;

  constructor(
    private readonly batchStorageService: BatchesParseStorageService,
    private readonly modalService: BsModalService,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  public ngOnInit() {}

  public changeSelected(selected: boolean) {
    this.changeCardSelected.emit({ id: this.departureAttachment.id, selected });
  }

  public openAddAttachmentModal() {
    if (this.isEditable) {
      this.modalService.show(AddAttachmentModalComponent, {
        initialState: {
          batchId: this.activatedRoute.snapshot.params['id'],
          batchDepartureId:
            this.activatedRoute.snapshot.queryParams['departureId'],
          attachmentId: this.departureAttachment.id,
          isEditMode: true,
        },
        ignoreBackdropClick: false,
        class: 'modal-dialog-centered modal-lg',
      });
    }
  }

  public ngOnDestroy() {}
}
